<template>
	<!-- eslint-disable vuetify/grid-unknown-attributes -->
	<v-card :v-can="readPermission">
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$note"
				start
			/>
			<translate>Notes</translate>
		</v-card-title>
		<v-card-text>
			<v-row class="pb-4">
				<v-col>
					<note-list
						outlined
						:notes="notes"
						:anonymized="anonymized === '1'"
						:model-name="modelName"
					/>
				</v-col>
			</v-row>
			<v-progress-linear
				:active="loading"
				:indeterminate="true"
			/>
			<v-row :v-can="createPermission">
				<v-col>
					<translate>
						Has there been contact with the customer?
					</translate>
					<v-radio-group
						v-model="note.contactContext"
						class="mt-0"
						inline
						@update:model-value="updateContext"
					>
						<br>
						<v-radio
							v-for="context in contactContexts"
							:key="context.context"
							:label="$gettext(context.context)"
							:value="context"
						/>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-row
				v-if="contactContexts && contactMediums"
				:v-can="createPermission"
				class="mt-0"
			>
				<v-col
					v-if="note.contactContext.mediumRequired"
					class="pt-0"
				>
					<translate>
						Customer has contacted through:
					</translate>
					<v-radio-group
						v-model="note.contactMedium"
						inline
						class="mt-0"
					>
						<v-radio
							v-for="medium in contactMediums"
							:key="medium.medium"
							:label="$gettext(medium.medium)"
							:value="medium"
						/>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-row :v-can="createPermission">
				<v-col class="pb-0">
					<v-textarea
						v-model="note.text"
						:placeholder="$gettext('Note text') + '...'"
						variant="outlined"
						rows="4"
						:disabled="loading"
					/>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-row
				v-if="contactContexts && contactMediums"
				:v-can="createPermission"
			>
				<v-col class="text-right pt-0">
					<v-btn
						color="primary"
						:disabled="loading"
						@click="submit"
					>
						<translate>Add note</translate>
					</v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	displayError,
} from 'laravel-front-library';
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'BackofficeNotes',

	props: {
		modelName: {
			type: String,
			required: true,
		},
		modelId: {
			type: Number,
			required: true
		},
		anonymized: {
			type: String,
			required: true
		}
	},

	data () {
		return {
			userId: 6,
			notes: [],
			loading: false,
			endpoint: '/api/v0/' + this.modelName + 'notes',
			readPermission: this.modelName + 'note.read',
			createPermission: this.modelName + 'note.create',
			contactMediums: null,
			noContact: {
				id: null,
				context: this.$gettext('There was no contact'),
				mediumRequired: false
			},
			contactContexts: null,
			note: {
				text: '',
				contactContext: null,
				contactMedium: null
			}
		};
	},

	computed: {
		textStyle () {
			return this.note.contactContext.mediumRequired ? 'colour: lightgrey' : 'colour: black';
		}
	},

	created () {
		this.getOptions();
		this.getNotes();
	},

	methods: {
		/**
		 *
		 */
		getOptions () {
			axios.get('/api/v0/notecontactcontexts').then(({
				data: data
			}) => {
				data.push(this.noContact);
				this.contactContexts = data;
				this.note.contactContext = this.noContact;
			});
			axios.get('/api/v0/notecontactmediums?sort_by=id').then(({
				data: data
			}) => {
				this.contactMediums = data.result;
			});
		},

		/**
		 * Retrieve the notes for this model.
		 *
		 * @returns {void}
		 */
		getNotes () {
			this.loading = true;
			axios.get(this.endpoint, {
				params: {
					[this.modelName + 'Id']: this.modelId,
				}
			}).then(({
				data,
			}) => {
				this.notes = data;
			}).catch((error) => {
				displayError(error);
			}).finally(() => {
				this.loading = false;
			});
		},

		/**
		 * @param {object} context
		 */
		updateContext (context) {
			if (context.mediumRequired === true) {
				this.note.contactMedium = this.contactMediums[0];
			} else {
				this.note.contactMedium = null;
			}
		},

		/**
		 * Submit to create a new note for this model
		 */
		submit () {
			if (this.note.text === '') {
				displayError(this.$gettext('No note provided.'));
				return;
			}

			this.loading = true;

			axios.post(this.endpoint, {
				[this.modelName + 'Id']: this.modelId,
				contactContextId: this.note.contactContext.id,
				contactMediumId: this.note.contactContext.mediumRequired ? this.note.contactMedium.id : null,
				note: this.note.text
			}).then(() => {
				this.getNotes();
				this.note.text = '';
				this.note.contactContext = this.noContact;
				this.note.contactMedium = null;
			}).catch((error) => {
				displayError(error.response.status === 500 ?
					this.$gettext('Failed to create the note.') :
					error.response.data);
			}).finally(() => {
				this.loading = false;
			});
		}
	}
};
</script>
